export default __webpack_public_path__ + "media/images/react_icons/bag-35aba911d80e6751a7577ce809b28d8a.svg";